import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { InputSwitchModule } from "primeng/inputswitch";
import { IconModule } from "../../../shared/icon/icon.module";
import { ToolTipModule } from "../../../shared/tool-tip/tool-tip.module";
import { SwitchGroupSamplingComponent } from "./switch-group-sampling.component";

@NgModule({
  imports: [
    CommonModule,
    InputSwitchModule,
    ReactiveFormsModule,
  ],
  declarations: [
    SwitchGroupSamplingComponent,
  ],
  entryComponents: [
    SwitchGroupSamplingComponent,
  ],
  exports: [
    SwitchGroupSamplingComponent,
  ],
})
export class SwitchGroupSamplingModule { }
